import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from "body-scroll-lock";
import pageHeader from "@/modules/section-header/helper";



const oldHeaderSticky = (selector) => {
  const logoElement = selector.querySelector(".logo__image");
  const logoSrc = logoElement.getAttribute('src');
  const logoForWhiteBg = 'dochub.svg';

  function handleScroll() {
    if (window.scrollY >= 5) {
      selector.classList.add('sticky-header');
      logoElement.setAttribute('src', logoSrc.replace(/[^/]+$/, logoForWhiteBg));
    } else {
      selector.classList.remove('sticky-header');
      logoElement.setAttribute('src', logoSrc);
    }
  }
  
  window.addEventListener('scroll', handleScroll);
}


if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

const mobileMenuDropDown = () => {
  const itemDropDown = document.querySelectorAll(".main-menu-toggler");
  const submenu = ".mobile-menu__submenu";

  itemDropDown.forEach(elem => {
    elem.addEventListener("click", event => {
      removeDropDownClass(elem);
      elem.classList.toggle("has-dropdown");
      elem.querySelectorAll(".mobile-menu__submenu")[0].style.display = "block";
      if (!elem.classList.contains("has-dropdown")) {
        elem.querySelectorAll(".mobile-menu__submenu")[0].style.display =
          "none";
      }
    });
  });
  const removeDropDownClass = item => {
    itemDropDown.forEach(elem => {
      if (item !== elem) {
        elem.classList.remove("has-dropdown");
        elem.querySelectorAll(".mobile-menu__submenu")[0].style.display =
          "none";
      }
    });
  };

  const dropdownInsideSubMenu = () => {
    const dropDownExpLink = document.querySelectorAll(".mobile-menu__submenu--dropdown .mobile-menu__submenu-link--bold");

    for (let i = 0; i < dropDownExpLink.length; i++) {
      const self = dropDownExpLink[i];

      self.addEventListener("click", function(e) {
        e.preventDefault();

        this.nextElementSibling.classList.toggle("is-active");
        this.closest(".mobile-menu__submenu--dropdown").classList.toggle("is-active");
      },);
    }
  };

  dropdownInsideSubMenu();
};

const dropDownSubmenu = () => {
  const submenuLink = document.querySelectorAll(".mobile-menu__submenu-link");
  const backButton = document.querySelector(
    ".js-mobile-nav-submenu__header-label"
  );
  const mobileMenu = document.querySelector(".mobile-menu__menu");
  const showNavSubmenu = "is-nav-submenu-active";
  const isActive = "is-active";

  submenuLink.forEach(elem => {
    elem.addEventListener("click", event => {
      event.stopPropagation();
      const menuType = event.target.getAttribute("data-navigate-to");
      if (menuType) {
        mobileMenu.classList.add(showNavSubmenu);
        document
          .querySelector(
            ".mobile-nav-submenu__body[data-menu=" + menuType + "]"
          )
          .classList.add(isActive);
      }
    });
  });

  if (backButton) {
    backButton.addEventListener("click", () => {
      mobileMenu.classList.remove(showNavSubmenu);
      document
        .querySelectorAll(".mobile-nav-submenu__body")
        .forEach(elem => elem.classList.remove(isActive));
    });
  }
};

const mobileHeaderPosition = () => {
  let count = 0;
  let lastScrollTop = 0;
  const desktopWidth = 960;
  const headerBar = document.querySelector(".page-header");
  const mobileMenu = document.querySelector(".layout-responsive__mobile-menu");

  if (window.innerWidth < desktopWidth && headerBar) {
    const offSet = headerBar.offsetHeight;
    headerBar.classList.add("is-active");
    window.addEventListener("scroll", () => {
      let scrollTop = window.scrollY;
      count++;
      if (scrollTop > lastScrollTop && offSet < lastScrollTop) {
        headerBar.classList.remove("is-active");
      } else if (count % 30 === 0 || offSet > scrollTop) {
        headerBar.classList.add("is-active");
      }
      lastScrollTop = scrollTop;

      
    });
  }
};

const headerSticky = () => {
  window.addEventListener("scroll", () => {
    const heightBody = document.documentElement.scrollTop;
    const headerShadow = document.querySelector(".js-header-shadow");
    const headerBar = document.querySelector(".page-header");
    const search = document.querySelector(".js-search-wrapper");
    const donateBanner = document.querySelector(".donate-ua-banner");
    const mobileMenu = document.querySelector(".layout-responsive__mobile-menu");

    if (heightBody > 31) {
      mobileMenu.classList.add('sticky');
    } else {
      mobileMenu.classList.remove('sticky');
    }

    if (headerShadow) {
      if (heightBody > 80) {
        headerShadow.classList.add("header-box-shadow");
        headerBar.classList.add("is-active");
        if (search) {
          search.classList.remove("is-visible");
          if (donateBanner) {
            donateBanner.classList.remove("donate-ua-banner--higher");
          }
        }
      } else {
        headerShadow.classList.remove("header-box-shadow");
      }
    }

    
  });
};

const desktopItemSubMenu = () => {
  const itemWithSubmenu = document.querySelectorAll(
    ".main-menu__item.has-dropdown"
  );
  const itemMenus = document.querySelectorAll(".main-menu__item");
  const headeMenuV1 = document.querySelectorAll(".main-menu");
  const desktopOverlay = document.querySelector(".layout-desktopOverlay");
  const cookieBanner = document.querySelector(".popup-cookie");

  itemMenus.forEach(elem => {
    elem.addEventListener("focusin", event => {
      const currentItem = event.target.parentElement;
      if (
        currentItem.classList.contains("main-menu__item") &&
        !currentItem.classList.contains("main-menu__item.has-dropdown")
      ) {
        itemWithSubmenu.forEach(elem => {
          setTimeout(() => {
            if (elem.classList.contains("is-open"))
              elem.classList.remove("is-open");
          }, 10);
        });
      }
    });
  });

  itemWithSubmenu.forEach(elem => {
    if (headeMenuV1) {

      var menuEnterTimeout;
      var menuLeaveTimeout;

      elem.addEventListener("touchstart", event => {
        const currentItem = event.target;

        if (currentItem.classList.contains("main-menu__link")) {
          const dropdown = currentItem.closest('.main-menu__item');
          dropdown.classList.toggle('is-open');

          if (!currentItem.getAttribute('href')) {
            event.preventDefault();
          }
        }

        if (currentItem.closest('.main-menu__dropdown-link')) {
          // Prevent the default link behavior
          if (!currentItem.getAttribute('href')) {
            event.preventDefault();
          }
        }

        if (!currentItem.closest('.main-menu__dropdown')) {
          const openDropdowns = document.querySelectorAll('.main-menu__item.has-dropdown.is-open');
          openDropdowns.forEach(elem => {
            if (!elem.contains(currentItem)) {
              elem.classList.remove('is-open');
            }
          });

          if (desktopOverlay) {
            const hasOpenMenu = document.querySelector('.main-menu__item.has-dropdown.is-open');
            desktopOverlay.classList.toggle('is-visible', hasOpenMenu);
          }
        }
      });


      elem.addEventListener("mouseenter", event => {
        const currentItem = event.target;

        clearTimeout(menuLeaveTimeout);

        menuEnterTimeout = setTimeout(function() {
          setTimeout(() => {
            if (!currentItem.classList.contains("is-open"))
              currentItem.classList.add("is-open");
            }, 10);
        }, 150);
      });

      elem.addEventListener("focusin", event => {
        const currentItem = event.target.parentElement;

        setTimeout(() => {
          if (!currentItem.classList.contains("is-open"))
            currentItem.classList.add("is-open");
        }, 10);
      });

      elem.addEventListener("mouseleave", event => {
        const currentItem = event.target;

        clearTimeout(menuEnterTimeout);

        menuLeaveTimeout = setTimeout(function() {
          setTimeout(() => {
            if (currentItem.classList.contains("is-open"))
              currentItem.classList.remove("is-open");
          }, 10);
        }, 150);
      });


    } else {
      elem.addEventListener("mouseenter", event => {
        const currentItem = event.target;
        setTimeout(() => {
          if (!currentItem.classList.contains("is-open"))
            currentItem.classList.add("is-open");
        }, 10);
      });

      elem.addEventListener("focusin", event => {
        const currentItem = event.target.parentElement;

        setTimeout(() => {
          if (!currentItem.classList.contains("is-open"))
            currentItem.classList.add("is-open");
        }, 10);
      });

      elem.addEventListener("mouseleave", event => {
        const currentItem = event.target;

        setTimeout(() => {
          if (currentItem.classList.contains("is-open"))
            currentItem.classList.remove("is-open");
        }, 10);
      });
    };
  });

  if (desktopOverlay) {
    desktopOverlay.addEventListener('touchstart', event => {
      // Close all open dropdowns
      const openDropdowns = document.querySelectorAll('.main-menu__item.has-dropdown.is-open');
      openDropdowns.forEach(dropdown => {
        dropdown.classList.remove('is-open');
      });
    });

    const itemsArray = [...itemWithSubmenu];
    const attrObserver = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.type !== "attributes" || mutation.attributeName !== "class") return;
    
        const hasOpenMenu = itemsArray.some(menu => menu.classList.contains("is-open"));
        desktopOverlay.classList.toggle("is-visible", hasOpenMenu);
        if (cookieBanner) {
          cookieBanner.classList.toggle("is-covered");
        }
      });
    });
    
    itemsArray.forEach(menu => attrObserver.observe(menu, { attributes: true }));


  }
};

const Offcanvas = () => {
  // anchorsAcademy();
  const toArray = nodeList => [].slice.call(nodeList);

  const generateTimestampId = () => {
    const timestamp = Date.now().toString(36);
    const randomPart = Math.random().toString(36).substring(2, 6);
    return timestamp + randomPart;
  }

  const options = {
    triggerSelector: "[data-offcanvas-trigger]",
    menuSelector: "[data-offcanvas-menu]",
    containerSelector: "[data-offcanvas-container]",
    // overlaySelector: "[data-offcanvas-overlay]"
  };

  const triggers = toArray(document.querySelectorAll(options.triggerSelector));
  const container = document.querySelector(options.containerSelector);
  // const overlay = document.querySelector(options.overlaySelector);
  const menu = document.querySelector(options.menuSelector);
  const body = document.querySelector("body");
  const mobileMenu = document.querySelector(".mobile-menu");
  const header = document.querySelector(".page-header--main");

  const hide = () => {
    menu.setAttribute("aria-hidden", "true");
    container.setAttribute("data-offcanvas-hidden", "true");
    // overlay.setAttribute("data-offcanvas-hidden", "true");
    header.removeAttribute("style");
    triggers.forEach(trigger => {
      trigger.setAttribute("aria-expanded", "false");
    });
    enableBodyScroll(mobileMenu);
    clearAllBodyScrollLocks();
  };

  const show = () => {
    disableBodyScroll(mobileMenu);
    menu.setAttribute("aria-hidden", "false");
    container.setAttribute("data-offcanvas-hidden", "false");
    // overlay.setAttribute("data-offcanvas-hidden", "false");
    header.style.boxShadow = 'none';
    triggers.forEach(trigger => {
      trigger.setAttribute("aria-expanded", "true");
    });
  };

  const isHidden = () => menu.getAttribute("aria-hidden") === "true";
  const toggle = () => (isHidden() ? show() : hide());
  const triggerClickHandler = () => toggle();

  triggers.forEach(trigger => {
    trigger.addEventListener("click", () => {
      triggerClickHandler();
    });
  });

  // if (overlay) overlay.addEventListener("click", () => hide());

  const setA11yAttributes = () => {
    const id = generateTimestampId();
    container.setAttribute("data-offcanvas-hidden", "true");
    if (menu) {
      menu.setAttribute('role', 'dialog');
      menu.setAttribute('tabindex', '-1');
      menu.setAttribute('aria-hidden', 'true');
      menu.setAttribute('id', id);
    }

    if (triggers && triggers.length > 0) {
      Array.prototype.forEach.call(triggers, trigger => {
        trigger.setAttribute('role', 'menuitem');
        trigger.setAttribute('aria-pressed', 'false');
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  };

  setA11yAttributes();
};


const headerLayout = document.querySelector(".layout__header");
const oldHeaderSelector = document.querySelector('.page-section--header');


export const headerFunctions = () => {
  
  if (headerLayout) {
    if (!oldHeaderSelector) {
      window.addEventListener("resize", () => {
        mobileHeaderPosition();
        headerSticky();
      });
    
      mobileMenuDropDown();
      dropDownSubmenu();
      mobileHeaderPosition();
      desktopItemSubMenu();
      headerSticky();
      Offcanvas();
      pageHeader();
    } else {
      oldHeaderSticky(oldHeaderSelector);
    }
  }
}

